import React from 'react';

import { Chip, CircularProgress, Stack, Typography } from '@mui/material';

import type { SurchargeRoomAssignment } from '../../types';

interface Props {
  isLoading: boolean;
  rooms: Array<SurchargeRoomAssignment>;
}

export default function SurchargeRoomsCell({ isLoading, rooms }: Props) {
  if (isLoading) {
    return (
      <Stack alignItems="center" direction="row" spacing={1}>
        <CircularProgress size={16} />
        <Typography color="text.secondary" variant="body2">
          Loading
        </Typography>
      </Stack>
    );
  }

  if (rooms.length === 0) {
    return (
      <Typography color="text.secondary" variant="body2">
        Not applied
      </Typography>
    );
  }

  return (
    <Stack alignItems="flex-start" spacing={0.75}>
      {rooms.map((room) => (
        <Chip
          key={`${room.roomTypeId}-${room.roomRateId}`}
          clickable={!!room.href}
          component={room.href ? 'a' : 'div'}
          {...(room.href ? { href: room.href, target: '_blank' } : {})}
          label={[room.roomName, room.ratePlanName, room.ratePlanCode ? `(${room.ratePlanCode})` : undefined]
            .filter(Boolean)
            .join(' - ')}
          size="small"
          variant="outlined"
        />
      ))}
    </Stack>
  );
}
